<template>
  <!--
   <form class="mt-6 flex space-x-4" action="#">
    <div class="flex-1 min-w-0">
       <label for="search" class="sr-only">Search</label>
       <div class="relative rounded-md shadow-sm">
         <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
           <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
         </div>
         <input type="search"
                name="search"
                id="search"
                class="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                placeholder="Search" />
       </div>
     </div>-->
<!--    <button type="submit"-->
<!--            class="inline-flex justify-center px-3.5 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none-->
<!--            focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">-->
<!--      <FilterIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />-->
<!--      <span class="sr-only">Search</span>-->
<!--    </button>
  </form>
  -->

  <div class=" sm:mt-0 sm:col-span-2">
    <div class="max-w-lg">
      <div class="relative flex items-start">
        <div class="flex items-center h-5">
          <input
              id="frontend"
              checked
              @change="setFilter"
              type="checkbox"
              class="focus:ring-blue-500 h-4 w-4 text-purple-500 border-gray-300 rounded frontend" />
        </div>
        <div class="ml-3 text-sm">
          <label for="frontend" class="font-medium text-gray-700">Frontend</label>
        </div>
      </div>
      <div class="relative flex items-start">
          <div class="flex items-center h-5">
            <input
                id="backend"
                checked
                @change="setFilter"
                type="checkbox"
                class="focus:ring-blue-500 h-4 w-4 text-purple-500 border-gray-300 rounded backend" />
          </div>
          <div class="ml-3 text-sm">
            <label for="backend" class="font-medium text-gray-700">Backend</label>
          </div>
        </div>
      <div class="relative flex items-start">
          <div class="flex items-center h-5">
            <input
                id="career"
                checked
                @change="setFilter"
                type="checkbox"
                class="focus:ring-blue-500 h-4 w-4 text-purple-500 border-gray-300 rounded career" />
          </div>
          <div class="ml-3 text-sm">
            <label for="career" class="font-medium text-gray-700">Career</label>
          </div>
        </div>
    </div>
  </div>

</template>

<script>
import {
  //FilterIcon,
  //SearchIcon,
} from "@heroicons/vue/solid/esm";

export default {
  name: "FilterCoaches",
  emits: ['change-filter'],
  components: {
   // FilterIcon,
    //SearchIcon,
  },
  data(){
    return{
      filters:{
        frontend: true,
        backend: true,
        career: true
      }
    }
  },
  methods: {
    setFilter(event){ //todo you always get event when using form elements
      console.log('filters before ', this.filters);
      const inputId = event.target.id;
      const isActive = event.target.checked;
      const updatedFilters = {
        ...this.filters,
        [inputId] : isActive,
      };
      this.filters = updatedFilters;
      console.log('filters after ', this.filters);
      this.$emit('change-filter', updatedFilters);
    }
  }
}
</script>
